import React from "react";

import { formatDeviceTimeZone } from "../lib/deviceDateTime";
import { Tooltip } from "../../shared/Tooltip/Tooltip";

interface Props {
  timeZone?: string | null;
}

export const DeviceTimeConfigCell = ({ timeZone }: Props) => {
  const { name, offset } = formatDeviceTimeZone(timeZone);

  return (
    <div className="DeviceTimeConfigCell">
      <Tooltip content={name}>
        <span className="DeviceTimeConfigCell__zone">{name}</span>
      </Tooltip>
      {offset ? (
        <span className="DeviceTimeConfigCell__offset">{offset}</span>
      ) : null}
    </div>
  );
};
